export default {
  // baseUrl: "http://localhost:8002/api",
  // baseUrl: "http://172.27.219.50:8002/api",
  baseUrl: "https://admin-bot.ast.fpt.net/api",
};
